<template>
<footer class="footer has-background-light">
  <div class="container has-text-centered">
    <strong>MJPMGR</strong> 是 <a href="https://sagi.team" target="_blank">SAGITEAM</a> 专用的后台管理系统。作者<a href="https://zengrong.net" target="_blank">曾嵘</a>。最后更新：{{ updated }}。
  </div>
</footer>
</template>

<script>
export default {
  name: 'appfooter',
  data () {
    return {
      updated: 'v1.1.7 2020-11-20 10:00:00'
    }
  }
}
</script>
